import React, { FC } from 'react';

import { Checkbox } from '@gravity-ui/uikit';
import i18n from '@yandex-int/i18n';
import { Field } from 'client/blocks/form/Field/Field';
import { Link } from 'client/blocks/Link/Link';
import { wrapInText } from 'client/lib/i18n-utils';
import { routes } from 'client/lib/routes';
import * as keyset from 'i18n/AppForm';

import styles from './VoiceControl.module.scss';

interface Props {
    voiceControlEnable: boolean;
    disabled: boolean;
    onVoiceControlChange?: (checked: boolean) => void;
    isAdvancedVoiceControl: boolean;
    onAdvancedVoiceControlChange?: (checked: boolean) => void;
}

const t = i18n(keyset);

const advancedVoiceControlDescription = wrapInText((s) => (
    <Link theme="info" external target="_blank" to={routes.documentation.aliceApps.voiceControlBeta}>
        {s}
    </Link>
))(t('voice-control-description-advanced'));

const advancedVoiceCatalogueMarkDescription = wrapInText(
    (s) => (
        <Link theme="info" external target="_blank" to={routes.documentation.aliceApps.voiceControlBeta}>
            {s}
        </Link>
    ),
    (s) => (
        <Link
            theme="info"
            external
            target="_blank"
            to={routes.documentation.aliceApps.advancedVoiceControlRequirements}
        >
            {s}
        </Link>
    ),
)(t('voice-control-advanced-subtitle'));

export const VoiceControl: FC<Props> = ({
    disabled,
    voiceControlEnable,
    onVoiceControlChange,
    isAdvancedVoiceControl,
    onAdvancedVoiceControlChange,
}) => {
    const handleVoiceControlChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!onVoiceControlChange) return;
        onVoiceControlChange(e.target.checked);
    };

    const handleAdvancedVoiceControlChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!onAdvancedVoiceControlChange) return;
        onAdvancedVoiceControlChange(e.target.checked);
    };

    return (
        <Field fieldTitle={t('voice-control-title')} fieldDescription={advancedVoiceControlDescription}>
            <Checkbox
                size="l"
                content={t('voice-control-label')}
                className={styles.formElement}
                checked={voiceControlEnable}
                disabled={disabled}
                onChange={handleVoiceControlChange}
            />
            <div className={styles.voiceControlCheckboxDescription}>{t('voice-control-subtitle')}</div>
            <Checkbox
                size="l"
                content={t('voice-control-advanced-label')}
                className={styles.formElement}
                checked={isAdvancedVoiceControl}
                disabled={disabled}
                onChange={handleAdvancedVoiceControlChange}
            />
            <div className={styles.voiceControlCheckboxDescription}>{advancedVoiceCatalogueMarkDescription}</div>
        </Field>
    );
};
